import { Checkbox } from "@material-tailwind/react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useStrategyStore } from "../../../_store/strategyRetireStore";
import { useUserStore } from "../../../_store/userStore";
import { MTButton } from "../../../components/button/MTButton";
import { FooterAfterSum } from "../../../components/FooterAfterSum/FooterAfterSum";
import { HeaderTitle } from "../../../components/header/Header";
import { ImageMain } from "../../../components/img/Img.Main";
import Container from "../../../components/layout/Container";
import NavigateGoBack from "../../../functions/Navigate.Goback";
import { InvestmentReturnCal } from "../../../functions/retirement/retirementFunction";
import {
  InvestmentReturnCalSensitive,
  InvestmentReturnCalSensitiveNormal,
} from "../../../functions/retirement/retirementFunctionAfter";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_CARD_BG,
  STYLE_FLEX_STATUS,
  STYLE_HEAD_STRAGADY,
  STYLE_MARGIN_TOP_PARENT,
} from "../../../utils/useStyle";
import { calPMTFVA } from "../../education/functions/function";
import { loopInvestmentAssetsAFSensitive } from "../functions/functionRetrementSensitivePlan";
import {
  dataAge,
  dataAgeAF,
  loopIncome,
  loopIncomeAF,
  loopInvestmentAssets,
  loopInvestmentAssetsAF,
  loopOutcome,
  loopOutcomeAF,
  loopRemain,
  loopRemainAF,
  loopReturnInvestment,
  loopReturnInvestmentAF,
} from "../functions/functionRetriementPlan";
import ViewAfterRetirePlan_Tab from "./VIAfterRetirePlan_Tab";
import { useEducationStore } from "../../../_store/educationStore";

const convertYearToMonth = (year) => {
  return year * 12;
};

const ViewSensitiveTest = ({
  strategyChange,
  lastResult,
  remain,
  // afterDiffYear,
  // sumAfterRetireInvest,
}) => {
  const userData = useUserStore((state) => state.userData);
  const retireData = useRetireStore((state) => state.retireData);
  const setRetireData = useRetireStore((state) => state.setRetireData);
  const strategy = useStrategyStore((state) => state.strategy);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const educationData = useEducationStore((state) => state.educationData);

  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const strategyLists = strategy?.map((item) => item?.key);

  useEffect(() => {
    const newRetireData = {
      ...retireData,
      is_plan: true,
      bf_plan_age: dataAge(),
      bf_plan_income: loopIncome(),
      bf_plan_outcome: loopOutcome(),
      bf_plan_remain: loopRemain(),
      bf_return_investment: loopReturnInvestment(),
      bf_investment_assets: loopInvestmentAssets(),

      af_plan_age: dataAgeAF(),
      af_plan_income: loopIncomeAF(),
      af_plan_outcome: loopOutcomeAF(),
      af_plan_remain: loopRemainAF(),
      af_return_investment: loopReturnInvestmentAF(),
      af_investment_assets: loopInvestmentAssetsAF(),
    };
    setRetireData(newRetireData);
  }, [
    setRetireData,
    retireData?.strategy_out_come,
    retireData?.strategy_income,
    retireData?.strategy_passive_income_retire,
    retireData?.strategy_assets_generate,
    retireData?.strategy_assets_generate_per_year,
    retireData?.strategy_salary,
    retireData?.strategy_salary_peryear,
    retireData?.strategy_control_rate_outcome,
    retireData?.strategy_age_retire,
    retireData?.strategy_age_dead,
    retireData?.strategy_investment_bf_retirement,
    retireData?.strategy_investment_af_retirement,
  ]);

  const [retireSensitiveData, setRetireSensitiveData] = useState([]);

  const straigyLists = strategy?.map((item) => item?.key);

  const retirementAgeAF = straigyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire
    : retireData?.age_retire;

  const afterDiffYear =
    retireData?.strategy_age_retire - retireData?.age_current;

  const dataPlanSensitive = retireSensitiveData?.map((item) => {
    return item?.results;
  });

  const getInvestSumSen = useMemo(() => {
    return userData?.is_premium
      ? InvestmentReturnCalSensitive(retireData, strategy, balanceData, educationData)?.map(
          (af_investment_assets, index) => {
            return {
              result: af_investment_assets?.asset_invest,
              age: retireData?.af_plan_age[index],
            };
          }
        )
      : InvestmentReturnCalSensitiveNormal(retireData, strategy)?.map(
          (af_investment_assets, index) => {
            return {
              result: af_investment_assets?.asset_invest,
              age: retireData?.af_plan_age[index],
            };
          }
        );
  }, [retireData]);

  const getremainSen = getInvestSumSen?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];

  const retireSen = getInvestSumSen.find(
    (result) => result.age === retirementAgeAF
  )?.result;

  const retirementAge = retireData?.age_retire;
  const remainSen = Number(getremainSen?.age) - 1;

  const getInvestSum = InvestmentReturnCal(
    retireData,
    balanceData,
    [],
    educationData
  )?.map((bf_investment_assets, index) => {
    return {
      result: bf_investment_assets?.asset_invest,
      age: retireData?.bf_plan_age[index],
    };
  });

  const lastResultSen = getInvestSumSen[getInvestSumSen?.length - 1];
  const retireBF = getInvestSum.find(
    (result) => result.age === retirementAge
  )?.result;

  const sumAfterRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(afterDiffYear);
    const calPercent = strategyLists?.includes(
      "strategy_investment_bf_retirement_change"
    )
      ? retireData?.strategy_investment_bf_retirement_change
      : retireData?.investment_bf_retirement;

    const sumPMT = calPMTFVA(
      Math.abs(lastResultSen?.result),
      calPercent / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);

  // หาอายุสุดท้าย
  const getAgeSensitive = retireSensitiveData?.filter((item) => {
    if (item?.results > 0) return item;
  });
  const ageSensitive = getAgeSensitive?.[getAgeSensitive?.length - 1]?.age;

  const lastResultInvest = lastResultSen?.result;

  useEffect(() => {
    setRetireSensitiveData(loopInvestmentAssetsAFSensitive());
  }, [retireData]);

  const onChangeCheckImagine = (e) => {
    setRetireData({ ...retireData, [e.target.name]: e.target.checked });
  };

  const dataPlanAF = () => {
    if (userData?.is_premium) {
      return InvestmentReturnCalSensitive(
        retireData,
        strategy,
        balanceData,
        educationData
      )?.map((af_investment_assets) => {
        return af_investment_assets?.asset_invest;
      });
    }

    return InvestmentReturnCalSensitiveNormal(retireData, strategy)?.map(
      (af_investment_assets) => {
        return af_investment_assets?.asset_invest;
      }
    );
  };

  return (
    <div id="first_reload">
      <Container>
        <HeaderTitle
          title="ทดสอบความอ่อนไหว"
          isGoback
          onClickGoBack={() => {
            setRetireSensitiveData([]);
            NavigateGoBack(navigate);
          }}
        />
        <div className={`${STYLE_MARGIN_TOP_PARENT} mb-10 px-6  `}>
          <div className=" mb-[18px]">
            {/*---------- ผลลัพธ์ ----------*/}
            {lastResultInvest > 0 ? (
              <div className=" text-center text-black text-md flex flex-col gap-[9px]">
                <ImageMain
                  src="/images/goodface.svg"
                  className="w-18 h-18 mx-auto"
                />
                <div>
                  <div>ยินดีด้วย...</div>
                  ท่านสามารถใช้ชีวิตหลังเกษียณได้ตามที่ท่านตั้งใจไว้
                </div>
              </div>
            ) : (
              <div className=" text-center text-black text-md flex flex-col gap-[9px]">
                <ImageMain
                  src="/images/badface.svg"
                  className="w-18 h-18 mx-auto"
                />
                <div>
                  ไม่นะ..เมื่อท่านอายุ {retireData?.age_dead} ปี
                  <div>เงินของท่านจะหมดลง ก่อนสิ้นอายุขัย</div>
                </div>
              </div>
            )}
          </div>

          {/*---- ความเคลื่อนไหวทางการเงิน ----*/}
          <div className={`${STYLE_CARD_BG} mb-[18px]  px-4`}>
            <ViewAfterRetirePlan_Tab
              onClickSTG={() => {}}
              dataaf={dataPlanAF()}
              labelsaf={dataAgeAF()}
              showPaire={retireData?.strategy_sum}
              lastResult={lastResultSen}
              retireResult={retireSen}
              remain={remainSen}
              strategyChange={retireData?.strategy_sum ? true : false}
              strategy={strategy}
              // setStrategy={setStrategy}
              isPass={true}
              retireData={retireData}
              setRetireData={setRetireData}
              onClick={() => {
                // setTabPlan(2);
              }}
              afterDiffYear={afterDiffYear}
              afterDiffYearCheck={afterDiffYear}
              sumAfterRetireInvest={sumAfterRetireInvest}
              userData={userData}
              IsSensitive={true}
            />
            <div className=" mt-[26px] mb-6 space-y-2.5 px-2">
              <MTButton
                width="w-full"
                onClick={() => navigate("/summarytablemovements?sensitive")}
                text="ดูรายละเอียด"
                color="border-maincyan bg-white"
                colortext="text-maincyan group-hover:text-white font-medium"
                hovercolor="hover:bg-maincyan group "
                variant="outlined"
              />
            </div>
          </div>

          {/*---------- อธิบายทดสอบความอ่อนไหว ----------*/}
          <div className={`${STYLE_CARD_BG} mb-[18px]`}>
            <div className=" flex flex-col gap-2 mb-[8px] ">
              <div className={STYLE_HEAD_STRAGADY}>สถานการณ์สมมติ</div>
              <div className={`border-b border-mainyellow w-[295px] `}></div>
            </div>
            <div className=" mt-[26px] mb-6 space-y-2.5 px-2">
              <div className="flex space-x-3">
                <Checkbox
                  size={"sm"}
                  containerProps={{
                    className: "p-1",
                  }}
                  ripple="false"
                  color="cyan"
                  name="check_imagine_one"
                  checked={retireData?.check_imagine_one}
                  onChange={onChangeCheckImagine}
                />
                <div className={STYLE_FLEX_STATUS}>
                  <ImageMain
                    src="/images/assetdown.svg"
                    className="w-6 h-6 flex-none"
                  />
                  <div className="  text-sm flex-none">
                    สถานการณ์ที่ 1
                    <div className="  text-sm ">
                      เศรษฐกิจถดถอย ผลตอบแทนการลงทุน
                      <div>
                        หลังเกษียณ เหลือเพียง{" "}
                        <span className=" font-semibold text-red300">1 %</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex space-x-3">
                <Checkbox
                  size={"sm"}
                  containerProps={{
                    className: "p-1",
                  }}
                  color="cyan"
                  name="check_imagine_two"
                  checked={retireData?.check_imagine_two}
                  onChange={onChangeCheckImagine}
                />
                <div className={STYLE_FLEX_STATUS}>
                  <ImageMain
                    src="/images/heart_medical.svg"
                    className="w-6 h-6 flex-none s"
                  />
                  <div className="  text-sm ">
                    สถานการณ์ที่ 2
                    <div className="  text-sm ">
                      เจ็บป่วยโรคร้ายแรงมีค่ารักษาพยาบาล
                      <div>
                        1 ล้านบาท ตอนอายุ{" "}
                        <span className=" font-semibold text-mainorange">
                          {`${retireData?.age_current + 5} ปี`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex space-x-3">
                <Checkbox
                  size={"sm"}
                  containerProps={{
                    className: "p-1",
                  }}
                  color="cyan"
                  name="check_imagine_three"
                  checked={retireData?.check_imagine_three}
                  onChange={onChangeCheckImagine}
                />
                <div className={STYLE_FLEX_STATUS}>
                  <ImageMain
                    src="/images/moneybag.svg"
                    className="w-6 h-6 flex-none"
                  />
                  <div className="  text-sm ">
                    สถานการณ์ที่ 3
                    <div className="  text-sm ">
                      ค้ำประกันให้ผู้อื่น เกิดหนี้ 5 ล้านบาท{" "}
                      <div>
                        ตอนอายุ{" "}
                        <span className=" font-semibold text-maingreen">
                          {`${retireData?.age_current + 10} ปี`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*--------- รอด / ไม่รอด ----------*/}
          {lastResultInvest > 0 ? (
            <div className=" flex flex-col justify-center mt-[18px]">
              <div className=" flex  justify-center items-center gap-[3px]">
                <ImageMain src="../images/taxicon3.png" className="w-8 h-8" />
                <div className=" text-mainblue font-semibold text-xl">
                  ยอดเยี่ยม
                </div>
              </div>
              <div className=" text-mainblue text-center text-sm mt-2">
                ถ้าเกิดสถานการณ์เหล่านี้ขึ้นจริง
                <div> การปรับกลยุทธ์เกษียณของคุณเป็นแผนที่ยอดเยี่ยม</div>
                <div>แต่ก็อย่าประมาทล่ะ</div>
              </div>
            </div>
          ) : (
            <div className=" flex flex-col justify-center mt-[18px]">
              <div className=" flex  justify-center items-center gap-[3px]">
                <ImageMain src="../images/badface_2.png" className="w-8 h-8" />
                <div className=" text-mainblue font-semibold text-xl">
                  ยังไม่ปลอดภัย
                </div>
              </div>
              <div className=" text-mainblue text-center text-sm mt-2">
                ถ้าเกิดสถานการณ์เหล่านี้ขึ้นจริง
                <div>การปรับกลยุทธ์เกษียณของคุณยังไม่ปลอดภัยเท่าที่ควร</div>
              </div>
            </div>
          )}

          <div className=" my-[18px]">
            <MTButton
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
              width="w-full"
              onClick={() => {
                setRetireSensitiveData([]);
                NavigateGoBack(navigate);
              }}
            />
          </div>

          <FooterAfterSum />
        </div>
      </Container>
    </div>
  );
};

export default ViewSensitiveTest;
